exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-5f58b8c4]{text-transform:uppercase}.col-6[data-v-5f58b8c4]{width:100%}.row[data-v-5f58b8c4]{margin-bottom:10px}.title-row[data-v-5f58b8c4]{margin-top:30px}label[data-v-5f58b8c4]{font-size:16px!important}span[data-v-5f58b8c4]{font-size:14px!important}.login-button[data-v-5f58b8c4]{width:50%;left:25%;position:relative;background-color:#ffb307;color:#fff;font-weight:700}.title[data-v-5f58b8c4]:after{content:\"\";display:block;width:4%;padding-top:10px;border-bottom:5px solid #ffb307}", ""]);

// exports
